/**
 * PLP card swatch hover preview.
 *
 * On desktop, hovering (or keyboard-focusing) an alternate-colour swatch on a
 * product card swaps the card's main image to the hovered colour's product
 * thumbnail. On mouse leave / blur, the preview fades back out, revealing the
 * underlying swiper image again.
 *
 * Touch devices: the CSS hides the preview overlay via `@media (hover: none)`,
 * and `mouseenter` doesn't fire on tap, so this is a no-op on mobile and the
 * swatch's `<a href>` click navigation runs as normal.
 *
 * Wiring (set in card-product.liquid + card-product-swatches.liquid):
 *   - .card-wrapper[data-card-id="<id>"]
 *   - img.card__swatch-preview[data-card-preview-for="<id>"]
 *   - ul.card-swatches[data-card-swatches-for="<id>"]
 *   - a.card-swatches__swatch[data-preview-src][data-preview-srcset][data-preview-alt]
 */
(function () {
  if (window.__cardSwatchHoverPreviewWired) return;
  window.__cardSwatchHoverPreviewWired = true;

  function getCardWrapper(swatch) {
    var ul = swatch.closest('.card-swatches');
    if (!ul) return null;
    var cardId = ul.getAttribute('data-card-swatches-for');
    if (!cardId) return null;
    return document.querySelector(
      '.card-wrapper[data-card-id="' + CSS.escape(cardId) + '"]'
    );
  }

  function getPreviewImg(wrapper) {
    return wrapper && wrapper.querySelector('.card__swatch-preview');
  }

  function showPreview(swatch) {
    var src = swatch.getAttribute('data-preview-src');
    if (!src) return;
    var wrapper = getCardWrapper(swatch);
    var img = getPreviewImg(wrapper);
    if (!img) return;

    var srcset = swatch.getAttribute('data-preview-srcset') || '';
    var alt = swatch.getAttribute('data-preview-alt') || '';
    var w = swatch.getAttribute('data-preview-width');
    var h = swatch.getAttribute('data-preview-height');

    // Only re-set src/srcset if changed, to avoid re-decoding on every enter.
    if (img.getAttribute('src') !== src) {
      img.setAttribute('src', src);
      if (srcset) img.setAttribute('srcset', srcset);
      img.setAttribute('alt', alt);
      if (w) img.setAttribute('width', w);
      if (h) img.setAttribute('height', h);
    }
    img.hidden = false;
    // Force a reflow so the transition runs even on the first show.
    void img.offsetWidth;
    img.classList.add('is-visible');
  }

  function hidePreview(swatch) {
    var wrapper = getCardWrapper(swatch);
    var img = getPreviewImg(wrapper);
    if (!img) return;
    img.classList.remove('is-visible');
  }

  function isSwatch(el) {
    return el && el.classList && el.classList.contains('card-swatches__swatch');
  }

  // Use capture-phase delegation so we catch mouseenter/leave (which don't bubble)
  // via mouseover/mouseout on document.
  document.addEventListener(
    'mouseover',
    function (e) {
      var target = e.target.closest && e.target.closest('.card-swatches__swatch');
      if (!target) return;
      // Ignore if mouse came from another element inside the same swatch.
      if (e.relatedTarget && target.contains(e.relatedTarget)) return;
      showPreview(target);
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (e) {
      var target = e.target.closest && e.target.closest('.card-swatches__swatch');
      if (!target) return;
      if (e.relatedTarget && target.contains(e.relatedTarget)) return;
      hidePreview(target);
    },
    true
  );

  // Keyboard accessibility — show preview on focus, hide on blur.
  document.addEventListener('focusin', function (e) {
    if (isSwatch(e.target)) showPreview(e.target);
  });
  document.addEventListener('focusout', function (e) {
    if (isSwatch(e.target)) hidePreview(e.target);
  });
})();
